import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin, Clock, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';

export const CaseStudyCard = ({ 
  beforeImage,
  afterImage,
  location,
  duration,
  budget,
  surface,
  projectType,
  onClick
}) => {
  return (
    <motion.div
      data-testid="case-study-card"
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
    >
      <Card className="overflow-hidden border border-slate-200/70 shadow-[0_10px_30px_rgba(15,23,42,0.08)] hover:shadow-[0_16px_44px_rgba(15,23,42,0.12)] transition-shadow duration-200">
        <div className="grid grid-cols-2 gap-0">
          <div className="relative aspect-square">
            <img src={beforeImage} alt="Avant" className="w-full h-full object-cover" />
            <div className="absolute top-2 left-2 bg-[#2B2B2B] text-white px-2 py-1 rounded text-xs font-medium">
              Avant
            </div>
          </div>
          <div className="relative aspect-square">
            <img src={afterImage} alt="Après" className="w-full h-full object-cover" />
            <div className="absolute top-2 right-2 bg-[#336DBF] text-white px-2 py-1 rounded text-xs font-medium">
              Après
            </div>
          </div>
        </div>
        <CardContent className="p-4 space-y-3">
          <div className="flex items-center justify-between">
            <Badge variant="secondary" className="text-xs">{projectType}</Badge>
            {budget && <span className="text-sm font-semibold text-[#336DBF]">{budget}</span>}
          </div>
          <div className="space-y-1.5 text-sm">
            {location && (
              <div className="flex items-center gap-2 text-slate-600">
                <MapPin className="w-4 h-4" />
                <span>{location}</span>
              </div>
            )}
            {duration && (
              <div className="flex items-center gap-2 text-slate-600">
                <Clock className="w-4 h-4" />
                <span>{duration}</span>
              </div>
            )}
            {surface && (
              <div className="flex items-center gap-2 text-slate-600">
                <TrendingUp className="w-4 h-4" />
                <span>{surface} m²</span>
              </div>
            )}
          </div>
          {onClick && (
            <Button 
              onClick={onClick}
              variant="outline" 
              className="w-full text-sm"
              data-testid="view-transformation-btn"
            >
              Voir la transformation
            </Button>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};